import React, { useEffect, useMemo, useRef, useState } from 'react';
import DataTable from 'components/Core/DataTable';
import { MotionButton } from 'components/Core/MotionStrap';
import DefaultHeader from 'components/PurchaserFrontend/Headers/DefaultHeader';
import PurchaserUsersManager from 'components/PurchaserFrontend/Users/PurchsaerUsersManager';
import Purchaser from '../../lib/Core/Backend/Controllers/Purchaser';
import NotificationAlert from "react-notification-alert";
import Notify from 'lib/Utils/Alert';
import Spinner from 'react-bootstrap/Spinner';
import {Button, Card, CardBody, CardTitle, CardHeader, Col, Container, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import RepresentativeUser from '../../lib/Core/Backend/Controllers/RepresentativeUsers';
import ConfirmationAlertTwo from 'components/ConfirmationAlert/ConfirmationAlertTwo';


const groups = {
  purchaser: 'PURCHASER',
  representative: 'PURCHASER_REPRESENTATIVE',
  manager: 'PURCHASER_USER_MANAGER',
  apiUser: 'PURCHASER_API_CLIENT'
}

const mapKeys = {
  active: 'active',
  apiUser: 'apiUser',
  permissions: 'permissions'
}

const PurchaserUsers = ({purchaserId, token}) => {

  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const representativeUsersClt = useMemo(() => new RepresentativeUser(token), [token]);
  const [modal, setModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [reload, setReload] = useState(false);

  const toggle = () => setModal(!modal);
  const toggleConfirm = () => setConfirmModal(!confirmModal);
  const triggerRelaod = () => setReload(!reload);

  const [activeOp, setActiveOp] = useState('Add new');
  const [contact, setContact] = useState(null);
  const [user, setUser] = useState(null);

  const [showAlertMessage, setShowAlertMessage] = useState(false)
  const [initialData, setInitialData] = useState({})
  const [loader,setLoader] = useState(true)
  const [addLoaderTwo,setAddLoaderTwo] = useState(false);
  const [editLoaderTwo,setEditLoaderTwo] = useState(false);
  const [apiUser, setApiUser] = useState(false);
  const [permissions, setPermissions] = useState(false);
  const [removeLoader,setRemoveLoader] = useState(false)

  const alert = useRef();
  const table = useRef();
  const userForm = useRef();
  const contactSelect = useRef();

  const stayModal = () => setShowAlertMessage(false)

  const header = [
    {title: 'Name', data: 'firstName', sortable: true, searchable: true, render: (data, type, row) => {
      if(data && row){
        return `${data} ${row.lastName}`
      } else {
        return 'Undefined';
      }
    }},
    {title: 'Email', data: 'username', sortable: true, searchable: true},
    {title: 'Permission level', data: 'groups', sortable: true, searchable: true, render: (data) => {
      if(data){
        if(data.includes(groups.manager, groups.purchaser, groups.representative)){
          return 'User Manager'
        } else {
          return 'Representative user'
        }
      }
      return 'Not found';
    }},
    {title: 'Active', data: 'enabled', sortable: true, searchable: true, render: (data) => {
      if(data)
        return 'Active';
      return 'Disabled';
    }},
  ]

	const addLoaderFile = () =>{
    setTimeout(() => {
      setAddLoaderTwo(false);
    }, 1500);
  }
const editLoaderFile = () =>{
  setTimeout(() => {
    setEditLoaderTwo(false);
  }, 1500);
}

  const leaveAllModal = () => {
		setShowAlertMessage(false)
		setModal(false)
	}

  const prepareToAdd = () => {
    setActiveOp('Add new');
    toggle();
  };

  const prepareToEdit = (row) => {
    setActiveOp('Edit');
    toggle();
    if(userForm.current){
      const rowData = row.data()
      const userData = {
        active: rowData.enabled,
        apiUser: rowData.groups.includes(groups.apiUser),
        permissions: rowData.groups.includes(groups.manager, groups.purchaser, groups.representative) ? true : false
      }

      setUser({ ...rowData });
      setApiUser(userData.apiUser);
      setPermissions(userData.permissions);

      userForm.current.active.checked = userData.active;
      // userForm.current.apiUser.checked = userData.apiUser;
      // userForm.current.permissions.checked = userData.permissions

      setInitialData({ ...userData })
    }
  };

  const finishOperation = (e) => {
    e.preventDefault();
		e.stopPropagation();

    if (userForm.current) {
      let newUser = {userGroups: [groups.purchaser]};

      if(activeOp === 'Add new'){
        if(apiUser === true){
          newUser.userGroups.push(groups.apiUser);
        }
        if(!contact){
          Notify(alert, 'danger', 'Select a contact');
          return
        }
      }

      switch (activeOp) {
        case 'Add new':
          setAddLoaderTwo(true)
          newUser.firstName = contact.contactFirstName;
          newUser.lastName = contact.contactLastName;
          newUser.username = contact.email;
          newUser.phoneNumber = contact.phone;
          newUser.acceptPrivacyPolicy = true;
          newUser.acceptTermsAndConditions = true;
          purchaserCtl.addPurchaserUser(purchaserId, contact.id, newUser, data => {
            if(data && !data.error){
              let addToGroups = [];
              if(permissions === true && apiUser === false){
                addToGroups.push(groups.purchaser, groups.representative, groups.manager);
              }  
              if(apiUser === true && permissions === false) {
                addToGroups.push(groups.purchaser, groups.representative, groups.apiUser);
              }

              if(apiUser === true && permissions === true){
                addToGroups.push(groups.purchaser, groups.representative, groups.apiUser ,groups.manager);
              }

              if(permissions === false && apiUser === false){
                addToGroups.push(groups.purchaser, groups.representative);
              }
              representativeUsersClt.addUserToGroups(data.id, addToGroups, groupsData => {
                if(groupsData.error || groupsData.errorMessage){
                  addLoaderFile();
                  Notify(alert, 'danger', groupsData.errorMessage ?? groupsData.error);
                } else {
                  Notify(alert, 'success', 'Successfully created User');
                  addLoaderFile();
                  toggle();
                  triggerRelaod();
                }
              });
              
            } else {  
              Notify(alert, 'danger', data.errorMessage ?? data.error);
              addLoaderFile();
            }
          });
        break;
        case 'Edit':
          setEditLoaderTwo(true)
          if(!!user){
            newUser.firstName = user.firstName;
            newUser.lastName = user.lastName;
            newUser.username = user.username;
            newUser.phoneNumber = user.phoneNumber;
            newUser.id = user.id;
            newUser.reprentativeUser = true;
            newUser.enabled = userForm.current.active.checked
            representativeUsersClt.editUser(newUser, data => {
              if(data && !data.error){
                if(!newUser.userManager){
                  representativeUsersClt.removeUserFromGroups(data.id, [groups.manager, groups.apiUser], removeGroupsData => {
                    if(removeGroupsData.error || removeGroupsData.errorMessage){
                      Notify(alert, 'danger', data.errorMessage ?? data.error);
                      editLoaderFile();
                    } else {
                      let groupsToUpdate = [groups.purchaser, groups.representative]
                      userForm.current.apiUser.checked && groupsToUpdate.push(groups.apiUser)
                      userForm.current.permissions.checked && groupsToUpdate.push(groups.manager)
                      representativeUsersClt.addUserToGroups(data.id, groupsToUpdate, groupsData => {
                        if(groupsData.error || groupsData.errorMessage){
                          Notify(alert, 'danger', groupsData.errorMessage ?? groupsData.error);
                          editLoaderFile()
                        } else {
                          Notify(alert, 'success', 'Successfully edited user');
                          editLoaderFile()
                          toggle();
                          triggerRelaod();
                        }
                      });
                    }
                  });
                } else {
                  representativeUsersClt.addUserToGroups(data.id, [groups.representative, groups.purchaser, groups.manager], groupsData => {
                    if(groupsData.error || groupsData.errorMessage){
                      editLoaderFile();
                      Notify(alert, 'danger', groupsData.errorMessage ?? groupsData.error);
                    } else {
                      Notify(alert, 'success', 'Successfully created User');
                      editLoaderFile();
                      toggle();
                      triggerRelaod();
                    }
                  });
                }
              } else {
                Notify(alert, 'danger', data.errorMessage ?? data.error);
                editLoaderFile()
              }
            })
          } else {
            Notify(alert, 'danger', 'Something went wrong reload the page');
            editLoaderFile();
          }
        break;
        default:
        break;
      }
    }
  };

  const confirmRemoval = (e) => {
    setRemoveLoader(true) 
    e.target.disabled = true;
    if(!!user){
      purchaserCtl.removeContact(purchaserId, user.contactId, (data) => {
       e.target.disabled = false;
          toggleConfirm();
          triggerRelaod();
        Notify(alert, 'danger', "User have been Removed");
        setTimeout(() => {
          setRemoveLoader(false)
        }, 1500);
      });
    } else {
      setTimeout(() => {
        setRemoveLoader(false)
      }, 1500);
      Notify(alert, 'danger', 'Something went wrong');
      toggleConfirm();
    }
  };

  const handleModalClose = () => {
    if (activeOp === 'Add New') {
			let hasChanges = false
			userForm.current.forEach(el => {
				if (!!el.value && el.value !== '-1') {
					hasChanges = true
				}
			})

			if (hasChanges) {
				setShowAlertMessage(true)
			} else {
				setModal(false)
			}

		} else {
			const formHasChanges = modelChange(initialData, userForm.current)
			if (formHasChanges){
				setShowAlertMessage(true)
			} else {
				setModal(!modal)
			}
		}
  }

  const modelChange = (initial, endModel) => {
		let changed = false
		Object.entries(initial).forEach(([key, value]) => {
			if (endModel[mapKeys[key]] && value !== endModel[mapKeys[key]].checked) {
				changed = true
				return
			}
		})
		return changed
	}



	const fetchPurchaserData = ()=> {
    

    purchaserCtl.purchaserCheck(purchaserId?`${purchaserId}`:0, (data) => {
      if (data && !data.error) {
        if(data?.users[0]?.enabled == false){
          sessionStorage.removeItem("accessToken")
            window.location.href="purchaser-auth/login"
    }
      }else{
       if((data?.errorMessage=="Purchaser not found"&& data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){

          Notify(alert, 'danger', data?.errorMessage ?? data?.error);
              sessionStorage.removeItem("accessToken")
              window.location.href="purchaser-auth/login"
          }
          if((data?.errorMessage.includes("Username was not found") && data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
    
            Notify(alert, 'danger', data?.errorMessage ?? data?.error);
                sessionStorage.removeItem("accessToken")
                window.location.href="purchaser-auth/login"
            }
      }
})
}

const getUserData = () =>{
  purchaserCtl.users(purchaserId, (data) => {
    if(data.length === 0 ){
      setLoader(false)
    }
    if(data && !data.error){
      setLoader(false)
      if(table.current){
        table.current.dataTable.clear().rows.add(data).draw();
      }
    } else {
      Notify(alert, 'danger', data.errorMessage ?? data.error);
    }
  })
}
useEffect(()=>{    

fetchPurchaserData()

},[purchaserId])

  useEffect(() => {
    if(purchaserId){
      getUserData()
    }
    
  },[reload, purchaserId, purchaserCtl]);

  return (
    <>
    <div className='mt-5 pt-5'>
      {/* <DefaultHeader /> */}
      <ConfirmationAlertTwo stayModal={stayModal} openModal={showAlertMessage} leaveModal={leaveAllModal} />
      <NotificationAlert ref={alert}/>
      <Container className="mt--5" fluid>
        <Row >
          <Col md={12}>
            <Card className="shadow">
              <CardHeader className="d-flex justify-content-between">
                <CardTitle tag="h1" className='mb-0'>Users list</CardTitle>
                <MotionButton className="py-2 motion_color" style={{color:"white"}} initial={{ x: "-500%", opacity: 0 }} animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  onClick={prepareToAdd}>
                  <i className="fas fa-user"style={{color:"white"}} />{' '}Create new User
                </MotionButton>
              </CardHeader>
              <CardBody >
              {loader ? 
                <div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
                :
                <div className="table-responsive">
                <DataTable
                  ref={table}
                  data={null}
                  className="j_add_order_table j_table_data_design"
                  options={{
                    saveState: false,
                    scrollY: '100px',
									  scrollCollapse: true,
                    order: [[0, "desc"]],
									  dom: 'tip',
                    language: { "paginate": { "next": "<i class='fas fa-angle-right'></i>", "previous": "<i class='fas fa-angle-left'></i>" } },
                  }}
                  columns={header}
                  addEditButtonTwo={{callback: prepareToEdit}}
                  addRemoveButton={{callback: (row) => {
                    setUser(row.data());
                    toggleConfirm();
                  }}}

                />
                </div>
               }
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal isOpen={modal} toggle={toggle} backdrop="static" centered={true} size="md">
          <ModalHeader toggle={handleModalClose} className='custom_header_colourTwo d-flex align-items-center justify-content-between'>{activeOp} User</ModalHeader>
          <ModalBody>
            <Form innerRef={userForm}>
              <PurchaserUsersManager activeOp={activeOp} purchaserId={purchaserId} contactSelect={contactSelect} setContact={setContact} token={token} 
              apiUser={apiUser}  setApiUser={setApiUser} permissions={permissions} setPermissions={setPermissions}  />
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={handleModalClose}>Cancel</Button>
            <Button type="button" className='btn btn-primaryTwo' onClick={finishOperation} disabled={addLoaderTwo || editLoaderTwo}>Save{
              addLoaderTwo || editLoaderTwo &&
                <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
            }</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={confirmModal} toggle={toggleConfirm} centered={true} backdrop="static">
				<ModalHeader className="custom_header_colourTwo align-items-center" toggle={toggleConfirm}>
          <h3 className='mb-0 ' style={{fontSize:'20px',color:"white"}}>Remove User</h3>
        </ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the user "{!!user  ? `${user.firstName} ${user.lastName}` : ""}"?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggleConfirm}>Cancel</Button>{' '}
					<Button className='btn btn-primaryTwo' onClick={confirmRemoval} disabled={removeLoader}>{!removeLoader && "Yes"}{
            removeLoader && 
            <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
            }</Button>
				</ModalFooter>
			</Modal>
      </Container>
      </div>
    </>
  );
}
 
export default PurchaserUsers;